var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(_vm.title)?_c('div',{staticClass:"card-title"}):_vm._e(),(_vm.subtitle)?_c('div',{staticClass:"card-subtitle"}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }